<template>
  <profile-modal-base
    :is-open="showModal"
    data-test="change-password-modal"
    @close="close"
  >
    <template #header>
      <profile-modal-header
        :header-text="'Change Password'"
        :back-target="'accountModal'"
      >
      </profile-modal-header>
    </template>
    <div class="wrapper">
      <password-input
        v-model="password"
        :label-text="'New Password'"
        data-test="new-password-input"
        :error-text="passwordErrorText"
      ></password-input>
      <password-input
        v-model="passwordConfirmation"
        :label-text="'Confirm Password'"
        data-test="confirm-password-input"
        :error-text="passwordConfirmationErrorText"
      ></password-input>
    </div>
    <span class="flex-1"></span>
    <div class="button-row">
      <button class="button-reset button-basic" @click="back">
        Cancel
      </button>
      <button class="button-reset button-primary font-semibold" @click="updatePassword">
        Update Password
      </button>
    </div>
  </profile-modal-base>
</template>

<script>
import PasswordInput from '@/components/singletons/PasswordInput.vue';
import ProfileModalBase from './ProfileModalBase.vue';
import ProfileModalHeader from './ProfileModalHeader.vue';
import ProfileModalMixin from '@/mixins/profileModal';

const MODAL_NAME = 'changePasswordModal';

export default {
  name: 'ChangePasswordModal',
  components: {
    PasswordInput,
    ProfileModalBase,
    ProfileModalHeader,
  },
  mixins: [ProfileModalMixin],
  data() {
    return {
      passwordConfirmation: '',
      passwordConfirmationErrorText: '',
      password: '',
      passwordErrorText: '',
    };
  },
  computed: {
    canUpdatePassword() {
      return this.password.length >= 8 && this.passwordConfirmation === this.password;
    },
    showModal() {
      return this.$store.getters['ui/profileModalShown'] === MODAL_NAME;
    },
  },
  watch: {
    password(newPassword) {
      if (newPassword.length > 0 && newPassword.length < 8) {
        this.passwordErrorText = 'must be at least 8 characters';
      } else {
        this.passwordErrorText = '';
      }
    },
    passwordConfirmation(newPasswordConfirmation) {
      if (newPasswordConfirmation !== this.password) {
        this.passwordConfirmationErrorText = 'does not match new password';
      } else {
        this.confirmPasswordErrorText = '';
      }
    },
  },
  methods: {
    back() {
      this.$store.commit('ui/setProfileModalShown', 'accountModal');
    },
    updatePassword() {
      if (this.canUpdatePassword) {
        const params = {
          user: {
            password: this.password,
            passwordConfirmation: this.passwordConfirmation,
          },
        };

        this.$store.dispatch('session/updateUser', params).then(response => {
          this.$notify({
            group: 'notifications',
            text: 'Password Updated Successfully',
            type: 'success',
          });
          this.back();
        }).catch(e => {
          this.$notify({
            group: 'notifications',
            text: 'Password Update Failed',
            type: 'error',
          });
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  margin-top: 1rem;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  gap: rem-calc(12);
}
</style>
